module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./create.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/create.md
// module id = 1KUt
// module chunks = 0